import { TextDividerCombinedProps } from './types';

const usePresenter = (props: TextDividerCombinedProps): TextDividerCombinedProps => {
  return props;
};

export default usePresenter;
